import http from '@/services/api';

const RESOURCE_NAME = 'api/contact';

export default {
  requestContacts() {
    const options = { headers: { 'cache-key': sessionStorage.getItem('org') } };
    return http.get(`${RESOURCE_NAME}`, options);
  },

  requestMainContacts() {
    return http.get(`${RESOURCE_NAME}/maincontacts`);
  },

  requestEnterpriseContacts() {
    const options = { headers: { 'cache-key': sessionStorage.getItem('org') } };
    return http.get(`${RESOURCE_NAME}/enterprisecontacts`, options);
  },

  requestExternalContacts() {
    const options = { headers: { 'cache-key': sessionStorage.getItem('org') } };
    return http.get(`${RESOURCE_NAME}/externalcontacts`, options);
  },

  createCrmContact(data) {
    return http.post('api/crm/contact', data);
  },

  updateCrmContactProperties(contactId, data) {
    return http.put(`api/crm/contact/${contactId}/properties`, data);
  },

  requestCrmContactDetails(contactId) {
    return http.get(`api/crm/contact/${contactId}`);
  },

  requestCrmContactDetailsBatch(payload) {
    return http.post(`api/crm/contact/batch`, { contactIds: payload });
  },

  requestCrmContactTemplateForBusinessProcess(contactId, businessProcessId) {
    return http.get(`api/crm/contact/${contactId}/template`, { params: { businessProcessId } });
  },

  basicSearchCrmContact(textToSearch, maxNumberOfResults = 50, pageNumber = 1) {
    return http.get('api/crm/basicSearch', {
      params: {
        textToSearch,
        maxNumberOfResults,
        pageNumber
      }
    });
  },

  advancedSearchCrmContact(searchCriteria, maxNumberOfResults = 50, pageNumber = 1) {
    return http.get('api/crm/advancedSearch', {
      params: {
        ...searchCriteria,
        maxNumberOfResults,
        pageNumber
      }
    });
  },

  requestAgentState(agentId) {
    return http.get(`api/agent/${agentId}/state`);
  },

  requestAgentStateBatch(payload) {
    return http.post(`api/agent/state/batch`, { agentIds: payload });
  },

  requestFavoriteContacts(agentId) {
    return http.get(`${RESOURCE_NAME}/favorites/${agentId}`);
  },

  createFavoriteContacts(agentId, payload) {
    return http.post(`${RESOURCE_NAME}/favorites/${agentId}`, payload);
  },

  updateFavoriteContacts(agentId, payload) {
    return http.put(`${RESOURCE_NAME}/favorites/${agentId}`, payload);
  },

  requestAgentInteractionHistory({ agentId, startTime, endTime, bpName, contactId, numDays, interactionType }) {
    return http.get(`${RESOURCE_NAME}/interactions/history`, {
      params: {
        agentId,
        startTime,
        endTime,
        bpName,
        contactId,
        numDays,
        interactionType
      }
    });
  },

  requestContactInteractionHistory(contactId) {
    return http.get(`api/crm/contact/${contactId}/interactionHistory`);
  },

  createContactNote(contactId, payload) {
    return http.put(`api/crm/contact/${contactId}/note`, payload);
  },

  getContactNotes(contactId) {
    return http.get(`api/crm/contact/${contactId}/note/all`);
  }
};
